module.exports = __webpack_public_path__ + "static/media/led.a9cdb8b3.jpg";